export let selectLabel = "msVPBb";
export default {selectLabel};